import {CORE, gateway} from '../../api';
import {getUriParams} from '../../../helpers/utils/utils';

export const findDevedorByDocumento = (documento) => {
  const query = getUriParams({documento});
  return gateway.get(`${CORE}/devedores?${query}`);
};
